import { APP_VERSION, CoreAppState } from '@aa/angular/core';
import { StaffAppLayoutComponent } from '@aa/angular/staff';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import LogRocket from 'logrocket';
import { environment } from 'src/libs/angular/core/src/lib/environments/environment';

@Component({
  standalone: true,
  imports: [RouterModule, StaffAppLayoutComponent],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  constructor(
    private matIconReg: MatIconRegistry,
    private readonly toastr: ToastrService,
    private readonly store: Store<CoreAppState>,
  ) {}

  ngOnInit(): void {
    if (environment.production) {
      LogRocket.init('au1iyf/the-card-professor');
    }
    console.log('APP VERSION', APP_VERSION);
    this.matIconReg.setDefaultFontSetClass('material-symbols-outlined');

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then((registration) => {
        registration.update();
      });
    }
  }
}
